// @ts-nocheck
import { SnackbarProvider } from 'notistack';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { ThemeProvider } from '@mui/material/styles';
import globalConfig from './config/globalConfig';
import { useEffect } from 'react';
import { initializePendo } from './services/pendo/pendo.service';
import { getLocalTenantData } from './utils/localTenantData';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { themes } from 'xg-cl';

import { LicenseInfo } from '@mui/x-license-pro';

LicenseInfo.setLicenseKey(globalConfig.muiLicense);

function App() {
  const ldClient = useLDClient();

  useEffect(() => {
    // Initialize Pendo for users with existing sessions or anonymous visitors
    const initializePendoForExistingSession = async () => {
      try {
        const userSessionStr = localStorage.getItem('userSession');
        const tenantData = getLocalTenantData();

        if (userSessionStr && tenantData) {
          // Authenticated user - initialize with user data
          const userSession = JSON.parse(userSessionStr);
          await initializePendo(userSession, tenantData);
        } else if (tenantData) {
          // Anonymous visitor (public pages) - initialize with anonymous ID
          const anonymousSession = {
            userId: 'anonymous',
            email: 'anonymous@visitor.com',
            firstName: 'Anonymous',
            lastName: 'Visitor'
          };
          await initializePendo(anonymousSession, tenantData);
        }
      } catch (error) {
        console.error('[App] Failed to initialize Pendo:', error);
      }
    };

    initializePendoForExistingSession();
  }, []);

  // Centralized LaunchDarkly tenant identification (XGE-2484)
  // This ensures all feature flags are evaluated per-tenant consistently
  useEffect(() => {
    const identifyTenantToLaunchDarkly = () => {
      try {
        const tenantData = getLocalTenantData();

        if (tenantData && ldClient) {
          const context = {
            kind: 'tenant',
            key: `${tenantData.tenantid}`,
            name: tenantData.name || tenantData.tenantname || '',
            domain: tenantData.domain || tenantData.tenantdomain || ''
          };

          ldClient.identify(context);

          if (globalConfig.isDevelop) {
            console.log(
              '[App] LaunchDarkly tenant context identified:',
              context
            );
          }
        } else if (ldClient && !tenantData) {
          // No tenant data available (e.g., before login)
          // Use anonymous context
          ldClient.identify({
            kind: 'user',
            key: 'anonymous',
            anonymous: true
          });

          if (globalConfig.isDevelop) {
            console.log('[App] LaunchDarkly anonymous context set');
          }
        }
      } catch (error) {
        console.error(
          '[App] Failed to identify tenant to LaunchDarkly:',
          error
        );
      }
    };

    identifyTenantToLaunchDarkly();
  }, [ldClient]);

  return (
    <ThemeProvider theme={themes.blueLightTheme}>
      <SnackbarProvider
        maxSnack={3}
        iconVariant={{
          error: <InfoOutlinedIcon />
        }}
      >
        <RouterProvider router={router} />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
